import React from 'react';
import { ThemeProvider } from 'styled-components';
import { ResponsiveProvider } from '../../utils/responsive.es.js';
import { defaultTheme } from '../../themes/defaultTheme.es.js';
import { ExperimentalProvider } from './ExperimentalProvider/ExperimentalProvider.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MaestroThemeProvider = ({
  theme = defaultTheme,
  mode = "dark",
  experiments,
  children
}) => {
  return /* @__PURE__ */ React.createElement(ResponsiveProvider, {
    theme
  }, /* @__PURE__ */ React.createElement(ExperimentalProvider, {
    experiments
  }, /* @__PURE__ */ React.createElement(ThemeProvider, {
    theme: __spreadProps(__spreadValues({}, theme), { mode })
  }, children)));
};
MaestroThemeProvider.displayName = "Maestro.ThemeProvider";

export { MaestroThemeProvider };
//# sourceMappingURL=MaestroThemeProvider.es.js.map
